import clsx from "clsx";

export interface Props {
  textColorClass?: string;
  bgColorClass?: string;
  children: React.ReactNode;
  onClick?: () => unknown;
  className?: string | string[];
}

const Tag = ({
  textColorClass,
  bgColorClass,
  className,
  onClick,
  children,
}: Props) => {
  const textSizePassed =
    className?.includes("text-xl") ||
    className?.includes("text-lg") ||
    className?.includes("text-md");

  return (
    <div
      className={clsx(
        className,
        "flex",
        "justify-center",
        "items-center",
        "m-1",
        "font-medium",
        "py-1",
        "px-2",
        "rounded-full",
        !textSizePassed && "text-xs",
        "font-semibold",
        !className?.includes("text-") && (textColorClass || "text-gray-700"),
        !className?.includes("bg-") && (bgColorClass || "bg-gray-200")
      )}
      onClick={onClick}
    >
      <div className="leading-none max-w-full flex-initial">{children}</div>
    </div>
  );
};

export default Tag;
